export interface CommonUrls {
    PRIVACY_POLICY: string;
    TERMS_OF_USE: string;
    LOCAL_SITE: string;
    ACCESSIBILITY: string;
    DO_NOT_SHARE: string;
}

export const URL_CONFIG: { [country: string]: CommonUrls } = {
    US: {
        PRIVACY_POLICY: 'https://www.servicemaster.com/privacy-policy/',
        TERMS_OF_USE: 'https://www.merrymaids.com/terms-of-use/',
        LOCAL_SITE: 'https://www.merrymaids.com',
        ACCESSIBILITY: 'https://merrymaids.com/accessibility-statement',
        DO_NOT_SHARE: 'https://servicemaster.com/do-not-sell-share-my-info',
    },
    Canada: {
        PRIVACY_POLICY: 'https://servicemaster.ca/privacy',
        TERMS_OF_USE: 'https://merrymaids.ca/terms-of-use/',
        LOCAL_SITE: 'https://www.merrymaids.ca',
        ACCESSIBILITY: 'https://merrymaids.ca/accessibility-statement',
        DO_NOT_SHARE: 'https://servicemaster.com/do-not-sell-share-my-info',
    },
};

export const OFFICE_ADDRESS_CONFIG: { [country: string]: string }  = {
    US: '1 Glenlake Parkway, Atlanta GA 30328',
    Canada: '2275 Upper Middle Road, Suite 200, Oakville, ON L6H 0C3',
};
